<template>
  <router-view v-if="!loading" />
</template>

<script setup>
import { onMounted, onUnmounted, ref } from 'vue';
import { loadPrimeVueLocale } from '@/plugins/i18n';
import { isInOffice } from '@/utils/isInOffice';
import { useRootStore } from '@/store/root';

const loading = ref(true);

const rootStore = useRootStore();

function handleWindowResize() {
  rootStore.updateWindowWidth(window.innerWidth);
  document.documentElement.style.setProperty(
    '--vh',
    `${window.innerHeight * 0.01}px`,
  );
}

onMounted(async () => {
  window.addEventListener('resize', handleWindowResize);
  await loadPrimeVueLocale();
  rootStore.updateWindowWidth(window.innerWidth);
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);

  if (isInOffice()) {
    document.documentElement.style.setProperty('--isOffice', 'true');
    document.querySelector('#app').classList.add('isOffice');
  }

  if (!rootStore.getIsInitialized) await rootStore.init(null);

  loading.value = false;
});

onUnmounted(() => {
  window.removeEventListener('resize', handleWindowResize);
});
</script>
